// key ใน localStorage - ต้องอยู่ข้ามการรีเฟรช เพราะผู้ใช้ออกไปทำอย่างอื่นระหว่างรอคิวได้
export const ENROLL_QUEUE_KEY = 'enrollQueue'

export const initialState = {
  // เลขบัตรคิวที่หลังบ้านออกให้ ใช้ถามลำดับจริงได้ทุกเมื่อ
  ticketId: null,
  // จำนวนใบที่อยู่หน้าเรา ณ ตอนเข้าคิว (ไว้คำนวณ % ของแถบ)
  total: 0,
  // เหลืออีกกี่ใบก่อนถึงเรา
  remaining: 0,
  trainingPlanUuid: null,
  // ใช้ถาม canRegister เผื่อบัตรไม่ถูกปิด (เช่น worker คนละเวอร์ชันหยิบไปทำ)
  courseUuid: null,
  // isWaiting = โชว์ popup อยู่ (คนละเรื่องกับการ "เฝ้าบัตร" ซึ่งดูจาก ticketId)
  isWaiting: false,
  // เวลาที่เริ่มเข้าคิว ใช้ตัดสินว่ารอนานเกินไปแล้วควรเปิด popup ให้เห็น
  startedAt: null,
  // true = กลับเข้ามาดูทีหลัง (socket ใบเดิมตายไปแล้ว)
  isResumed: false,
}
